export default "__VITE_ASSET__2e5a9f46__"